import { AnalyticsBrowser } from '@segment/analytics-next'
import { createContext } from 'react'

export const AnalyticsContext = createContext<AnalyticsBrowser | undefined>(
  undefined
)
